<template>
  <div class="programme" style="padding-top: 50px;">
    <div class="head">
      <img src="../../static/image/fangan_title.png" class="fullWidth" />
      <div class="head-t">
        <p>解决方案</p>
        <p>面向行业客户，我们提供安全、可靠、高质量、易扩展的解决方案，帮助客户实现信息化管理最佳实践，以满足客户业务快速发展的 不同需求</p>
      </div>
    </div>
    <Row type="flex" justify="center" class="code-row-bg">
      <Col style="width:1200px">
        <div style="height: 100px;"></div>
        <div class="fontfaYahei color33 font36" style="margin-left: 7%;">“我们的积累,见证了我们的成长”</div>
        <!-- <div style="height: 100px;" @mouseenter="clearEnter()"></div> -->
        <Row type="flex" justify="center" class="code-row-bg">
          <Col
            span="4"
            class="alignCenter curP"
            style="padding-bottom: 10px;"
            v-for="(item,index) in fanganList"
            :key="index"
          >
            <div
              :class="{indexActive:item.indexActive,indexActives:item.indexActives}"
              @mouseenter="anEnter(index)"
              @click="clickAn(index)"
            >{{item.name}}</div>
          </Col>
        </Row>
        <div style="height: 50px;" @mouseenter="clearEnter()"></div>

        <Row v-if="allShow">
          <Row>
            <Col
              span="8"
              style="float: left;margin-top:30px ;"
              v-for="(item,index) in allList"
              :key="index"
            >
              <div
                class="an-content curP gup"
                @mouseenter="fangAnEnter(index)"
                @mouseleave="out(index)"
              >
                <img :src="item.icon" class="fullWidth" style="width:100%;height: 250px;" />
                <div class="an-content-one bgonetwo" v-bind:style="{background:item.zhezhao}">
                  <div class="BTjuzhongP">
                    <div class="BTjuzhongC">
                      <img :src="item.icon_title" style="width: 20%;" />
                      <div style="height: 20px;"></div>
                      <div
                        class="centerLR"
                        style="height: 2px;width: 30%"
                        v-bind:style="{background:item.back}"
                      ></div>
                      <div style="height: 20px;"></div>
                      <div
                        class="fontfaYahei font18"
                        v-bind:style="{color:item.color}"
                      >{{item.name}}</div>
                      <div style="height: 20px;"></div>
                      <button v-if="item.btn" class="an-button">
                        <router-link
                          :to="{path:item.linkTo,query:{newId:item.id}}"
                          style="color:white"
                        >了解详情</router-link>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Row>
        <Row v-if="APPShow">
          <Col>
            <Row>
              <Col
                span="8"
                style="float: left;margin-top:30px ;"
                v-for="(item,index) in APPList"
                :key="index"
              >
                <div
                  class="an-content curP gup"
                  @mouseenter="fangAnAPPEnter(index)"
                  @mouseleave="outs(index)"
                >
                  <img :src="item.icon" class="fullWidth" style="width:100%; height: 250px;" />
                  <div class="an-content-one bgonetwo" v-bind:style="{background:item.zhezhao}">
                    <div class="BTjuzhongP">
                      <div class="BTjuzhongC">
                        <img :src="item.icon_title" style="width: 20%;" />
                        <div style="height: 20px;"></div>
                        <div
                          class="centerLR"
                          style="height: 2px;width: 30%"
                          v-bind:style="{background:item.back}"
                        ></div>
                        <div style="height: 20px;"></div>
                        <div
                          class="fontfaYahei font18"
                          v-bind:style="{color:item.color}"
                        >{{item.name}}</div>
                        <div style="height: 20px;"></div>
                        <button v-if="item.btn" class="an-button">
                          <router-link
                            :to="{path:item.linkTo,query:{newId:item.id}}"
                            style="color:white"
                          >了解详情</router-link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row v-if="wzShow">
          <Col span="20">
            <Row>
              <Col
                span="8"
                style="float: left; margin-top:30px "
                v-for="(item,index) in wzList"
                :key="index"
              >
                <div
                  class="an-content curP gup"
                  @mouseenter="fangAnwzEnter(index)"
                  @mouseleave="outser(index)"
                >
                  <img :src="item.icon" class="fullWidth" style="width:100%; height: 250px;" />
                  <div class="an-content-one bgonetwo" v-bind:style="{background:item.zhezhao}">
                    <div class="BTjuzhongP">
                      <div class="BTjuzhongC">
                        <img :src="item.icon_title" style="width: 20%;" />
                        <div style="height: 20px;"></div>
                        <div
                          class="centerLR"
                          style="height: 2px;width: 30%"
                          v-bind:style="{background:item.back}"
                        ></div>
                        <div style="height: 20px;"></div>
                        <div
                          class="fontfaYahei font18"
                          v-bind:style="{color:item.color}"
                        >{{item.name}}</div>
                        <div style="height: 20px;"></div>
                        <button v-if="item.btn" class="an-button">
                          <router-link
                            :to="{path:item.linkTo,query:{newId:item.id}}"
                            style="color:white"
                          >了解详情</router-link>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div style="height: 80px;"></div>
        <Page
          :total="total"
          class="centerLR"
          :current.sync="draw"
          @on-change="changePage"
          :page-size="pageSize"
        />
        <div style="height: 50px;"></div>
      </Col>
    </Row>
    <xfck></xfck>
  </div>
</template>

<script>
import $ from "jquery";
import xfck from "./xfck.vue";

var img_url_i = "";
// if (window.location.host.slice(0, 5) === "local") {
//   img_url_i = "..";
// } else {
//   img_url_i = "/jianyunPC";
// }
export default {
  name: "programme",
  data() {
    return {
      pageSize: 9,
      total: 0,
      total1: 0,
      total2: 0,
      total3: 0,
      allShow: true,
      APPShow: false,
      wzShow: false,
      anHeight: (($(window).width() * (16 / 24)) / 3) * (251 / 381) + "px",
      fanganList: [
        // {
        //   name: "全部解决方案",
        //   indexActive: true,
        //   indexActives: true,
        //   val: "all"
        // },
        // {
        //   name: "APP解决方案",
        //   indexActive: false,
        //   indexActives: false,
        //   val: "APP"
        // },
        // {
        //   name: "网站建设解决方案",
        //   indexActive: false,
        //   indexActives: false,
        //   val: "wz"
        // }
      ],
      allList: [],
      APPList: [],
      wzList: [],
      page: 1,
      isShowThis: 1,
      draw: 1
    };
  },
  mounted() {
    this.getOne();
    this.getTwo();
    this.getThree();
  },
  methods: {
    getOne() {
      var that = this;
      var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
      that.allList = [];
      that.axios
        .get(url, { params: { region: 10086, page: that.page } })
        .then(res => {
          res.data.data.forEach(function(item, index) {
            that.total1 = Number(res.data.cmd);
            that.total = that.total1;
            item.name = item.title;
            item.icon = that.getData.CDN_IMG + item.image;
            item.icon_title = img_url_i + "/static/image/jiejue1.png";
            item.back = "#F8EEEE";
            item.color = "#FFFFFF";
            item.zhezhao = "rgba(0, 0, 0, .5)";
            item.btn = false;
            item.linkTo = "/proDetail";
            that.allList.push(item);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTwo() {
      var that = this;
      that.APPList = [];
      var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
      that.axios
        .get(url, { params: { region: 7, page: that.page } })
        .then(res => {
          res.data.data.forEach(function(item, index) {
            that.total2 = Number(res.data.cmd);
            item.name = item.title;
            item.icon = that.getData.CDN_IMG + item.image;
            item.icon_title = img_url_i + "/static/image/jiejue1.png";
            item.back = "#F8EEEE";
            item.color = "#FFFFFF";
            item.zhezhao = "rgba(0, 0, 0, .5)";
            item.btn = false;
            item.linkTo = "/proDetail";
            that.APPList.push(item);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getThree() {
      var that = this;
      that.wzList = [];
      var url = that.baseUrl + "/jianyunadmin/api.php?c=business_news_list";
      that.axios
        .get(url, { params: { region: 8, page: that.page } })
        .then(res => {
          res.data.data.forEach(function(item, index) {
            that.total3 = Number(res.data.cmd);
            item.name = item.title;
            item.icon = that.getData.CDN_IMG + item.image;
            item.icon_title = img_url_i + "/static/image/jiejue1.png";
            item.back = "#F8EEEE";
            item.color = "#FFFFFF";
            item.zhezhao = "rgba(0, 0, 0, .5)";
            item.btn = false;
            item.linkTo = "/proDetail";
            that.wzList.push(item);
          });
        })
        .catch(error => {
          console.log(error);
        });
    },
    anEnter(index) {
      let that = this;
      that.fanganList.map(function(item) {
        item.indexActive = false;
      });
      that.fanganList[index].indexActive = true;
    },
    clickAn(index) {
      let that = this;
      that.fanganList.map(function(item) {
        item.indexActive = false;
        item.indexActives = false;
      });
      that.fanganList[index].indexActive = true;
      that.fanganList[index].indexActives = true;
      that.page = 1;
      that.draw = 1;
      if (that.fanganList[index].val === "all") {
        that.allShow = true;
        that.APPShow = false;
        that.wzShow = false;
        that.isShowThis = 1;
        that.total = that.total1;
      } else if (that.fanganList[index].val === "APP") {
        that.allShow = false;
        that.APPShow = true;
        that.wzShow = false;
        that.isShowThis = 2;
        that.total = that.total2;
      } else if (that.fanganList[index].val === "wz") {
        that.allShow = false;
        that.APPShow = false;
        that.wzShow = true;
        that.isShowThis = 3;
        that.total = that.total3;
      }
    },
    out(index) {
      let that = this;
      that.allList[index].icon_title = that.allList[index].icon_title.replace(
        /.png/g,
        "1.png"
      );
      that.allList[index].back = "#F8EEEE";
      that.allList[index].color = "#FFFFFF";
      that.allList[index].zhezhao = "rgba(0, 0, 0, .5)";
      that.allList[index].btn = false;
    },
    outs(index) {
      let that = this;
      that.APPList[index].icon_title = that.APPList[index].icon_title.replace(
        /.png/g,
        "1.png"
      );
      that.APPList[index].back = "#F8EEEE";
      that.APPList[index].color = "#FFFFFF";
      that.APPList[index].zhezhao = "rgba(0, 0, 0, .5)";
      that.APPList[index].btn = false;
    },
    outser(index) {
      let that = this;
      that.wzList[index].icon_title = that.wzList[index].icon_title.replace(
        /.png/g,
        "1.png"
      );
      that.wzList[index].back = "#F8EEEE";
      that.wzList[index].color = "#FFFFFF";
      that.wzList[index].zhezhao = "rgba(0, 0, 0, .5)";
      that.wzList[index].btn = false;
    },
    //鼠标滑过
    fangAnEnter(index) {
      let that = this;
      that.allList.map(function(item) {
        if (!(item.icon_title.indexOf("1.png") !== -1)) {
          item.icon_title = item.icon_title.replace(/.png/g, "1.png");
          item.back = "#F8EEEE";
          item.color = "#FFFFFF";
          item.zhezhao = "rgba(0, 0, 0, .5)";
          item.btn = false;
        }
      });
      that.allList[index].icon_title = that.allList[index].icon_title.replace(
        /1.png/g,
        ".png"
      );
      that.allList[index].back = "#999999";
      that.allList[index].color = "#333333";
      that.allList[index].zhezhao = "rgba(255, 255, 255, .5)";
      that.allList[index].btn = true;
    },
    fangAnAPPEnter(index) {
      let that = this;
      that.APPList.map(function(item) {
        if (!(item.icon_title.indexOf("1.png") !== -1)) {
          item.icon_title = item.icon_title.replace(/.png/g, "1.png");
          item.back = "#F8EEEE";
          item.color = "#FFFFFF";
          item.zhezhao = "rgba(0, 0, 0, .5)";
          item.btn = false;
        }
      });
      that.APPList[index].icon_title = that.APPList[index].icon_title.replace(
        /1.png/g,
        ".png"
      );
      that.APPList[index].back = "#999999";
      that.APPList[index].color = "#333333";
      that.APPList[index].zhezhao = "rgba(255, 255, 255, .5)";
      that.APPList[index].btn = true;
    },
    bgcolor(index) {
      console.log(index);
    },
    fangAnwzEnter(index) {
      let that = this;
      that.wzList.map(function(item) {
        if (!(item.icon_title.indexOf("1.png") !== -1)) {
          item.icon_title = item.icon_title.replace(/.png/g, "1.png");
          item.back = "#F8EEEE";
          item.color = "#FFFFFF";
          item.zhezhao = "rgba(0, 0, 0, .5)";
          item.btn = false;
        }
      });
      that.wzList[index].icon_title = that.wzList[index].icon_title.replace(
        /1.png/g,
        ".png"
      );
      that.wzList[index].back = "#999999";
      that.wzList[index].color = "#333333";
      that.wzList[index].zhezhao = "rgba(255, 255, 255, .5)";
      that.wzList[index].btn = true;
    },
    clearEnter(index) {
      let that = this;
      that.fanganList.map(function(item) {
        item.indexActive = false;
      });
    },
    changePage(e) {
      var that = this;
      that.page = e;
      if (that.isShowThis === 1) {
        that.getOne();
      } else if (that.isShowThis === 2) {
        that.getTwo();
      } else if (that.isShowThis === 3) {
        that.getThree();
      }
    }
  },
  components: {
    xfck
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.BTjuzhongC {
  padding-top: 55px;
}
.head {
  position: relative;
}
.head-t {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 50%;
  font-size: 14px;
  font-family: MicrosoftYaHeiLight;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
}
.head-t > p:nth-child(1) {
  font-size: 36px;
  margin-bottom: 50px;
}
.gup {
  width: 380px;
  height: 250px;
}
.bgonetwo {
  width: 380px;
  height: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/programme.vue